import React, { useState, useEffect, useContext } from "react";
import { BarbershopContext } from "../providers/useProvider";
import { forgetPassword } from "../api/authService";
import { useNavigate } from "react-router-dom"; // For navigating after login

const useForgetPassword = () => {
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState(null);
  const { config } = useContext(BarbershopContext);
  const navigate = useNavigate();

  const handleForgetPassword = async (email) => {
    setMessage(null);
    try {
      const response = await forgetPassword(email, config.brandName);
      if (response.isSuccess) {
        setMessage({ text: response.value, type: "success" });
        setShowMessage(true);
        // Wait 4 seconds, then call run
        setTimeout(() => navigate(`/login`), 4000);
      } else {
        setMessage({ text: response.errors.join("\n"), type: "danger" });
        setShowMessage(true);
      }
    } catch (err) {
      setMessage(
        err.response?.data?.message ||
          "Failed to reset your password. Your link may have expired."
      );
    }
  };
  return {
    handleForgetPassword,
    message,
    setShowMessage,
    showMessage,
    config,
  };
};
export default useForgetPassword;
